/**
 * AuthLayout — single editorial page for login (and future password flows).
 *
 * Layout: full-bleed paper background with an asymmetric two-column split.
 * Left column carries the editorial brand mark + tagline (the "magazine
 * masthead" feel).  Right column is the form, anchored to the upper-third
 * for visual tension rather than vertical-centre balance.
 *
 * The fine grain texture (.grain) and the leading rule above the form give
 * it the feel of a journal title page.
 */
import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="grain min-h-dvh grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] bg-[var(--color-paper)]">
      {/*
        Left rail — editorial masthead.
        Hidden on mobile so the form claims the full screen.
      */}
      <aside className="hidden lg:flex relative flex-col justify-center p-12 border-r border-[var(--color-rule)]">
        <div className="reveal mb-12">
          <div className="eyebrow">SADT · LOADING PLATFORM</div>
        </div>

        <div className="reveal" style={{ animationDelay: "120ms" }}>
          <h1 className="display text-[clamp(2.5rem,5vw,4rem)] leading-[0.98] max-w-[18ch]">
            The annual instructor loading workbook,
            <span className="italic text-[var(--color-accent)]"> reborn</span> as a
            living dataset.
          </h1>
          <p className="mt-8 max-w-[42ch] text-[var(--color-ink-2)] text-[var(--text-base)] leading-[1.6]">
            Multi-department workload calculations, audited edits, and a chat
            agent grounded in the same numbers your spreadsheet has always shown.
          </p>
        </div>

      </aside>

      {/* Right column — auth form mounts here */}
      <main className="flex items-start lg:items-center justify-center px-6 py-16 lg:py-12">
        <div className="w-full max-w-[24rem]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
